import React from 'react';
import PropTypes from 'prop-types';

function BlockBuilderSectionAnchor({ value }) {
  return (
    <div
      id={`section-id-${value.sectionId}`}
      style={{
        height: '1px',
      }}
    />
  );
}

BlockBuilderSectionAnchor.propTypes = {
  value: PropTypes.shape({
    sectionId: PropTypes.string.isRequired,
  }).isRequired,
};

export default BlockBuilderSectionAnchor;
